import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hideable" ]

  showTargets() {
    this.hideableTargets.forEach(el => {
      el.classList.add("block")
    });
  }

  hideTargets() {
    this.hideableTargets.forEach(el => {
      el.classList.add("hidden")
    });
  }

  toggleTargets() {
    this.hideableTargets.forEach((el) => {
      if(el.classList.contains("hidden")) {
        el.classList.add("block")
        el.classList.remove("hidden")
      } else {
        el.classList.add("hidden")
        el.classList.remove("block")
      }
    });
  }
}
